import styled from 'styled-components';

export const VehicleBannerWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.color.white};
`;

export const VehicleBannerLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px 16px;
  padding: 16px 20px;

  @media (min-width: ${({ theme }) => theme.breakpoint.lg}px) {
    padding: 16px 20px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.md - 1}px) {
    align-items: flex-start;
  }
`;

export const VehicleBannerContent = styled.div`
  flex: 1 1 480px;
  min-width: 280px;
`;

export const VehicleBannerActions = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  align-self: center;
`;

export const VehicleBannerMobileActions = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 6px;
  border-top: 1px solid ${({ theme }) => theme.color.grey90_dark_80};
`;
